if (!customElements.get('lazy-section')) {
  customElements.define(
    'lazy-section',
    class LazySection extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 800px 0px' }
        );
        this.observer.observe(this.section);
      }

      disconnectedCallback() {
        this.observer.disconnect();
      }

      async load() {
        const { section } = this;

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const rendered = html.getElementById(section.id);
          if (!rendered) throw new Error(`#${section.id} missing from response`);

          section.replaceChildren(...rendered.childNodes);

          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(section);
        } catch (error) {
          console.error(`Lazy section ${this.dataset.sectionId} failed to load`, error);
        }
      }
    }
  );
}
